import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';

const Description = function Description({ discount }) {
    return (
        <FormattedMessage
            id="dbl.authmodal.promoCode.description"
            defaultMessage="Save {discount}% on your first purchase"
            values={{ discount }}
        />
    );
};

Description.propTypes = {
    discount: PropTypes.number,
};

export const placeholders = defineMessages({
    enterYourZipCode: {
        id: 'dbl.authmodal.enteryourzipcode',
        defaultMessage: 'Enter your zip code',
    },
});

export default {
    accountCreated: (
        <FormattedMessage
            id="dbl.authmodal.accountcreated"
            defaultMessage="Your account has been successfully created"
        />
    ),
    applyNow: <FormattedMessage id="dbl.authmodal.applynow" defaultMessage="Apply Now >" />,
    accountLogin: (
        <FormattedMessage
            id="dbl.authmodal.accountlogin"
            defaultMessage="Already have an account?"
        />
    ),
    askLater: <FormattedMessage id="dbl.authmodal.asklater" defaultMessage="Ask later" />,
    close: <FormattedMessage id="dbl.authmodal.close" defaultMessage="Close" />,
    yourFirmsProfile: (
        <FormattedMessage
            id="dbl.authmodal.yourFirmsProfile"
            defaultMessage="Your Firm's Profile"
        />
    ),
    contactDealerConfirmation: (
        <FormattedMessage
            id="dbl.authmodal.contactdealerconfirmation"
            defaultMessage="Your message has been sent to the dealer"
        />
    ),
    socialRegisterConfirmationFacebook: (
        <FormattedMessage
            id="dbl.authmodal.socialregisterconfirmationfacebook"
            defaultMessage="You've logged in with Facebook."
        />
    ),
    socialRegisterConfirmationGoogle: (
        <FormattedMessage
            id="dbl.authmodal.socialregisterconfirmationgoogle"
            defaultMessage="You've logged in with Google."
        />
    ),
    continueButton: (
        <FormattedMessage id="dbl.authmodal.continuebutton" defaultMessage="Continue" />
    ),
    continueShopping: (
        <FormattedMessage id="dbl.authmodal.continueshopping" defaultMessage="Continue Shopping" />
    ),
    dealerApplyDescription: (
        <FormattedMessage
            id="dbl.authmodal.dealerapplydescription"
            defaultMessage="1stdibs only showcases items from vetted, professional sellers and galleries that have gone through our approval process. This means personal items cannot be sold by sellers who have not been approved and selected."
        />
    ),
    easyCheckoutBlurb: (
        <FormattedMessage
            id="dbl.authmodal.easycheckoutblurb"
            defaultMessage="Easy Online Checkout"
        />
    ),
    errorMessages: {
        currentPasswordRequired: (
            <FormattedMessage
                id="dbl.authmodal.error.currentpasswordrequired"
                defaultMessage="You must provide your current password"
            />
        ),
        consumerZipCode: (
            <FormattedMessage
                id="dbl.authmodal.error.consumerzipcode"
                defaultMessage="Please provide your zip code"
            />
        ),
        currentPasswordInvalid: (
            <FormattedMessage
                id="dbl.authmodal.error.currentpasswordinvalid"
                defaultMessage="Current password provided is incorrect."
            />
        ),
        emailConflict: (
            <FormattedMessage
                id="dbl.authmodal.error.emailconflict"
                defaultMessage="This email address has already been registered."
            />
        ),
        emailInvalid: (
            <FormattedMessage
                id="dbl.authmodal.error.emailinvalid"
                defaultMessage="Please enter a valid email address."
            />
        ),
        emailNotFound: (
            <FormattedMessage
                id="dbl.authmodal.error.emailnotfound"
                defaultMessage="That email address is not in our records. Please check the email address you entered."
            />
        ),
        firmAddress: (
            <FormattedMessage
                id="dbl.authmodal.error.firmaddress"
                defaultMessage="Please provide a valid address"
            />
        ),
        firmCountry: (
            <FormattedMessage
                id="dbl.authmodal.error.firmcountry"
                defaultMessage="Please select the country in which you operate"
            />
        ),
        firmName: (
            <FormattedMessage
                id="dbl.authmodal.error.firmname"
                defaultMessage="Please provide your firm's name"
            />
        ),
        firmProjectsPerYear: (
            <FormattedMessage
                id="dbl.authMethod.error.firmProjectsPerYear"
                defaultMessage="Please provide projects per year"
            />
        ),
        firmProjectValue: (
            <FormattedMessage
                id="dbl.authMethod.error.firmProjectValue"
                defaultMessage="Please provide annual project value"
            />
        ),
        firmSize: (
            <FormattedMessage
                id="dbl.authmodal.error.firmsize"
                defaultMessage="Please select a firm size"
            />
        ),
        firmSpecialty: (
            <FormattedMessage
                id="dbl.authmodal.error.firmspecialty"
                defaultMessage="Please select a firm speciality"
            />
        ),
        firmWebsite: (
            <FormattedMessage
                id="dbl.authmodal.error.firmwebsite"
                defaultMessage="Please provide valid URL"
            />
        ),
        firmZipCode: (
            <FormattedMessage
                id="dbl.authmodal.error.firmzipcode"
                defaultMessage="Please provide a valid postal code"
            />
        ),
        firstName: (
            <FormattedMessage
                id="dbl.authmodal.error.firstname"
                defaultMessage="Please provide your first name"
            />
        ),
        forgotPasswordSystemFailure: (
            <FormattedMessage
                id="dbl.authmodal.error.forgotpasswordsystemfailure"
                defaultMessage="Forgot Password Error! Please contact support@1stdibs.com to recover your password"
            />
        ),
        lastName: (
            <FormattedMessage
                id="dbl.authmodal.error.lastname"
                defaultMessage="Please provide your last name"
            />
        ),
        loginSystemFailure: (
            <FormattedMessage
                id="dbl.authmodal.error.loginsystemfailure"
                defaultMessage="Login Error! Please contact support@1stdibs.com"
            />
        ),
        registrationSystemFailure: (
            <FormattedMessage
                id="dbl.authmodal.error.registrationsystemfailure"
                defaultMessage="Registration Error! Please contact support@1stdibs.com"
            />
        ),
        loginUnauthorized: (
            <FormattedMessage
                id="dbl.authmodal.error.loginunauthorized"
                defaultMessage="The email/password combination does not match our records. Passwords are case sensitive."
            />
        ),
        passwordInvalid: (
            <FormattedMessage
                id="dbl.authmodal.error.passwordinvalid"
                defaultMessage="Please enter a minimum of 5 characters."
            />
        ),
        passwordRequired: (
            <FormattedMessage
                id="dbl.authmodal.error.passwordrequired"
                defaultMessage="Password is required."
            />
        ),
        passwordsDoNotMatch: (
            <FormattedMessage
                id="dbl.authmodal.error.passwordsdonotmatch"
                defaultMessage="The passwords do not match. Please check the passwords that you entered."
            />
        ),
        passwordsMustBeDifferent: (
            <FormattedMessage
                id="dbl.authmodal.error.passwordsmustbedifferent"
                defaultMessage="New password must be different than current password"
            />
        ),
        phoneNumber: (
            <FormattedMessage
                id="dbl.authmodal.error.phonenumber"
                defaultMessage="Please provide valid phone number"
            />
        ),
        roleAtFirm: (
            <FormattedMessage
                id="dbl.authmodal.error.roleAtFirm"
                defaultMessage="Please select a role"
            />
        ),
        firmType: (
            <FormattedMessage
                id="dbl.authmodal.error.firmType"
                defaultMessage="Please select a firm type"
            />
        ),
        reasonForJoining: (
            <FormattedMessage
                id="dbl.authmodal.error.reasonForJoining"
                defaultMessage="Please select a reason for joining"
            />
        ),
        userTypeRequired: (
            <FormattedMessage
                id="dbl.authmodal.error.usertyperequired"
                defaultMessage="User Type is Required"
            />
        ),
        updatePasswordSystemFailure: (
            <FormattedMessage
                id="dbl.authmodal.error.updatepasswordsystemfailure"
                defaultMessage="Update Password Error! Please contact support@1stdibs.com"
            />
        ),
    },
    finishRegistration: (
        <FormattedMessage
            id="dbl.authmodal.finishregistration"
            defaultMessage="Finish Registration"
        />
    ),
    globalShippingBlurb: (
        <FormattedMessage id="dbl.authmodal.globalshippingblurb" defaultMessage="Global Shipping" />
    ),
    verifyBusiness: (
        <FormattedMessage id="dbl.authmodal.verifyBusiness" defaultMessage="Verify Your Business" />
    ),
    applyForTrade: (
        <FormattedMessage
            id="dbl.authmodal.applyForTrade"
            defaultMessage="Apply for Trade Membership"
        />
    ),
    leadingMarketPlace: (
        <FormattedMessage
            id="dbl.authmodal.leadingmarketplace"
            defaultMessage="The leading marketplace for beautiful things"
        />
    ),
    learnAboutDealerProgram: (
        <FormattedMessage
            id="dbl.authmodal.learnaboutdealerprogram"
            defaultMessage="Apply to Sell on 1stdibs"
        />
    ),
    login: <FormattedMessage id="dbl.authmodal.login" defaultMessage="Log In" />,
    notReady: <FormattedMessage id="dbl.authmodal.notready" defaultMessage="Not ready yet?" />,
    personalize: (
        <FormattedMessage
            id="dbl.authmodal.personalize"
            defaultMessage="Personalize Your Experience"
        />
    ),
    preferencesSaved: (
        <FormattedMessage
            id="dbl.authmodal.preferencesSaved"
            defaultMessage="Your Preferences Have Been Saved"
        />
    ),
    receiveAssuranceBlurb: (
        <FormattedMessage
            id="dbl.authmodal.receiveAssuranceBlurb"
            defaultMessage="Guaranteed Buyer Protection"
        />
    ),
    shopWithConfidence: (
        <FormattedMessage
            id="dbl.authmodal.shopWithConfidence"
            defaultMessage="Shop For Beautiful Things With Confidence"
        />
    ),
    socialMediaInstructions: (
        <FormattedMessage
            id="dbl.authmodal.socialMediaInstructions"
            defaultMessage="If you don't have any official documentation, please share your firm's social media details:"
        />
    ),
    submitApplicationButton: (
        <FormattedMessage
            id="dbl.authmodal.submitApplicationButton"
            defaultMessage="Submit Application"
        />
    ),
    submitButton: <FormattedMessage id="dbl.authmodal.submitButton" defaultMessage="Submit" />,
    tellUsAboutYourself: (
        <FormattedMessage
            id="dbl.authmodal.tellUsAboutYourself"
            defaultMessage="Please tell us why you’ve come to 1stdibs, so we can share benefits most relevant to you."
        />
    ),
    tellUsWhoYouAreShoppingFor: (
        <FormattedMessage
            id="dbl.authmodal.tellUsWhoYouAreShoppingFor"
            defaultMessage="Please tell us why you’ve come to 1stdibs, so we can share benefits most relevant to you."
        />
    ),
    tellUsYourZipcode: (
        <FormattedMessage
            id="dbl.authmodal.tellUsYourZipcode"
            defaultMessage="Please tell us your zipcode so that we can show you localized shipping rates."
        />
    ),
    applicationSubmitted: (
        <FormattedMessage
            id="dbl.authmodal.applicationSubmitted"
            defaultMessage="Application Submitted"
        />
    ),
    userTypeLabels: {
        consumer: (
            <FormattedMessage
                id="dbl.authmodal.userTypeLabels.consumer"
                defaultMessage="I am shopping for myself"
            />
        ),
        dealer: (
            <FormattedMessage
                id="dbl.authmodal.userTypeLabels.dealer"
                defaultMessage="I am an independent seller with items to put onsite for sale"
            />
        ),
        trade: (
            <FormattedMessage
                id="dbl.authmodal.userTypeLabels.trade"
                defaultMessage="I am an interior designer or architect shopping for a client"
            />
        ),
    },
    welcomeBack: <FormattedMessage id="dbl.authmodal.welcomeBack" defaultMessage="Welcome Back" />,
    welcomeTo1stdibs: (
        <FormattedMessage id="dbl.authmodal.welcomeTo1stdibs" defaultMessage="Welcome to 1stdibs" />
    ),
    weMakeShoppingEasy: (
        <FormattedMessage
            id="dbl.authmodal.weMakeShoppingEasy"
            defaultMessage="Whether you are an experienced collector or you recently discovered a passion for design, we make shopping for rare and unique pieces easy. Complete your purchase on 1stdibs to receive these important shopping benefits:"
        />
    ),
    referralHeader: (
        <FormattedMessage id="dbl.authmodal.referralHeader" defaultMessage="Invite Your Team" />
    ),
    referralSubheader: (
        <FormattedMessage
            id="dbl.authmodal.referralSubheader"
            defaultMessage="Give your team access to trade pricing by inviting them to join the 1stdibs trade program."
        />
    ),
    promoCode: {
        title: (
            <FormattedMessage
                id="dbl.authmodal.promoCode.title"
                defaultMessage="Account Created!"
            />
        ),
        subtitle: (
            <FormattedMessage
                id="dbl.authmodal.promoCode.subtitle"
                defaultMessage="We want to welcome you with an exclusive offer."
            />
        ),
        description: Description,
        codeText: <FormattedMessage id="dbl.authmodal.promoCode.codeText" defaultMessage="CODE:" />,
        details: (
            <FormattedMessage id="dbl.authmodal.promoCode.details" defaultMessage="See details" />
        ),
        cartText: (
            <FormattedMessage
                id="dbl.authmodal.promoCode.cartText"
                defaultMessage="Secure online checkout"
            />
        ),
        shippingText: (
            <FormattedMessage
                id="dbl.authmodal.promoCode.shippingText"
                defaultMessage="Easy global checkout"
            />
        ),
        assuranceText: (
            <FormattedMessage
                id="dbl.authmodal.promoCode.assuranceText"
                defaultMessage="Guaranteed buyer protection"
            />
        ),
        button: (
            <FormattedMessage id="dbl.authmodal.promoCode.button" defaultMessage="Start Shopping" />
        ),
    },
    firmInfoUpdated: (
        <FormattedMessage
            id="dbl.authmodal.firmInfoUpdated"
            defaultMessage="Your Firm Profile has been Updated"
        />
    ),
    updateUserPreferences: (
        <FormattedMessage
            id="dbl.authModal.updateUserPreferences"
            defaultMessage="Update them at any time and view personalized content on your {discoverPage}."
            values={{
                discoverPage: (
                    <a href="/favorites/discover/" data-tn="discover-page-link">
                        <FormattedMessage
                            id="dbl.authmodal.discoverPage"
                            defaultMessage="Discover page"
                        />
                    </a>
                ),
            }}
        />
    ),
};
